import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcc9975c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caron-general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sty" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "general-title" }, "概况", -1))
const _hoisted_4 = { class: "general-content" }
const _hoisted_5 = { class: "item-data" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "公顷", -1))
const _hoisted_7 = { class: "item-des" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataType, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['item-icon',item.icon])
          }, null, 2),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(['number',item.color])
            }, _toDisplayString(item.data), 3),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.des), 1)
        ]))
      }), 128))
    ])
  ]))
}